import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const Lottie = ({ path }) => {
  const ref = useRef(null);

  useEffect(() => {
    import('lottie-web').then((lottie) => {
      lottie.loadAnimation({
        container: ref.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path
      });
    });
  }, [path]);

  return <section className="lottie" ref={ref} />;
};

Lottie.propTypes = {
  path: PropTypes.string.isRequired
};

export default Lottie;
